<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="shop-inner-content">
    <div class="loading-mask" :class="{ active: !dataIsLoad }" />
    <div class="photo-content col-12 col-lg-8">
      <Photo :photo-cover="true" />
    </div>
    <div class="spec-content col-12 col-lg-4">
      <Spec />
    </div>
    <div class="d-lg-none photo-content col-12">
      <Photo :photo-cover="false" />
    </div>
    <!-- 加價購手機 -->
    <div class="d-lg-none col-12">
      <AddonShop :market-id="CustomMarketID.substring(0, CustomMarketID.indexOf('CL'))" />
    </div>
    <div class="col-12 col-lg-8">
      <Recommend />
    </div>
  </div>
</template>

<script setup>
import { watch } from 'vue';

import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';
import { fireShopContentView } from '@global/gtm/product';

import Photo from '@page/shopContent/components/Photo.vue';
import Spec from '@page/shopContent/components/Spec.vue';
import AddonShop from '@page/shopContent/components/AddonShop.vue';
import Recommend from '@page/shopContent/components/Recommend.vue';

const { CustomMarketID } = window;

const shopContentStore = useShopContentStore();
const { itemDatas, selectedDataID, dataIsLoad, selectedData } = storeToRefs(shopContentStore);
const { getData, getRecommendData, getSelectedData } = shopContentStore;

watch(selectedDataID, () => {
  getSelectedData();

  fireShopContentView({
    customMarketID: window.CustomMarketID,
    name: itemDatas.value.Name,
    price: itemDatas.value.SellPrice,
    affiliation: selectedData.value.Name,
    eventName: itemDatas.value.Events?.length ? itemDatas.value.Events[0]?.Name : '',
  });
});

getData();
getRecommendData();
</script>
